"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadDsnTransformGraphicsGenerator = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const TransformSchematic_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematic");
const TransformSchematicDrawing_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematicDrawing");
const TransformImageExtraction_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformImageExtraction");
const orcadLayers_1 = require("../../../orcadLayers");
const orcadShapeConverters_1 = require("../../../orcadShapeConverters");
const OrcadDsnSymbolUtils_1 = require("./OrcadDsnSymbolUtils");
const orcadImageUtils_1 = require("../../../orcadImageUtils");
const imageAssets_1 = require("../../../../imageAssets");
const ModelText_1 = require("../../../../../ModelText");
class OrcadDsnTransformGraphicsGenerator {
    constructor() {
        this.runsFor = [TransformSchematic_1.TransformSchematic];
    }
    *generate(parent, _rootContext) {
        const page = parent.hierarchyEntry.page;
        for (const commentText of page.GraphicCommentTextInst ?? []) {
            yield new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [orcadLayers_1.OrCadSchLayerMap[sigma_engine_shared_1.SchLayerType.Label].id],
                drawing: {
                    type: 'text',
                    ...(0, ModelText_1.encodeStrippedText)({ raw: commentText.Name, dialects: [ModelText_1.TextDialect.Orcad] }),
                    pos: [commentText.LocX, commentText.LocY],
                    angle: commentText.Rotation ?? 0,
                    justify: [-1, 0],
                    size: (0, OrcadDsnSymbolUtils_1.scaleFont)(commentText.Font),
                    thickness: 1,
                },
            });
        }
        const otherLayer = orcadLayers_1.OrCadSchLayerMap[sigma_engine_shared_1.SchLayerType.Other].id;
        for (const line of page.GraphicLineInst ?? []) {
            for (const drawing of orcadShapeConverters_1.OrCadShapeConvert.graphicLineInst()(line)) {
                yield new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                    layers: [otherLayer],
                    drawing,
                });
            }
        }
        for (const box of page.GraphicBoxInst ?? []) {
            for (const drawing of orcadShapeConverters_1.OrCadShapeConvert.graphicBoxInst()(box)) {
                yield new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                    layers: [otherLayer],
                    drawing,
                });
            }
        }
        for (const polygon of page.GraphicPolygonInst ?? []) {
            for (const drawing of orcadShapeConverters_1.OrCadShapeConvert.graphicPolygonInst()(polygon)) {
                yield new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                    layers: [otherLayer],
                    drawing,
                });
            }
        }
        for (const polyline of page.GraphicPolylineInst ?? []) {
            for (const drawing of orcadShapeConverters_1.OrCadShapeConvert.graphicPolylineInst()(polyline)) {
                yield new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                    layers: [otherLayer],
                    drawing,
                });
            }
        }
        const imageLayer = orcadLayers_1.OrCadSchLayerMap[sigma_engine_shared_1.SchLayerType.Image].id;
        for (const bitmap of page.GraphicBitMapInst ?? []) {
            if (!bitmap.Value) {
                continue;
            }
            const { data, mimeType } = (0, imageAssets_1.decodeBase64Image)(bitmap.Value);
            const ref = (0, imageAssets_1.computeImageRef)(`bitmap-${bitmap.DbId}`, mimeType);
            const width = Math.abs(bitmap.X2 - bitmap.X1);
            const height = Math.abs(bitmap.Y2 - bitmap.Y1);
            yield new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [imageLayer],
                drawing: {
                    type: 'image',
                    pos: [Math.min(bitmap.X1, bitmap.X2), Math.min(bitmap.Y1, bitmap.Y2)],
                    width,
                    height,
                    imageRef: ref,
                },
            });
            yield new TransformImageExtraction_1.TransformImageExtraction(parent, ref, `bitmap-${bitmap.DbId}`, data, mimeType);
        }
        for (const oleEmbed of page.GraphicOleEmbedInst ?? []) {
            if (!oleEmbed.Dib) {
                continue;
            }
            const { data, mimeType } = (0, orcadImageUtils_1.decodeDibToBmp)(oleEmbed.Dib);
            const ref = (0, imageAssets_1.computeImageRef)(`ole-${oleEmbed.DbId}`, mimeType);
            const width = Math.abs(oleEmbed.X2 - oleEmbed.X1);
            const height = Math.abs(oleEmbed.Y2 - oleEmbed.Y1);
            yield new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [imageLayer],
                drawing: {
                    type: 'image',
                    pos: [Math.min(oleEmbed.X1, oleEmbed.X2), Math.min(oleEmbed.Y1, oleEmbed.Y2)],
                    width,
                    height,
                    imageRef: ref,
                },
            });
            yield new TransformImageExtraction_1.TransformImageExtraction(parent, ref, `ole-${oleEmbed.DbId}`, data, mimeType);
        }
    }
}
exports.OrcadDsnTransformGraphicsGenerator = OrcadDsnTransformGraphicsGenerator;
//# sourceMappingURL=OrcadDsnTransformGraphicsGenerator.js.map